<div [formGroup]="formGroup" class="mb-3">
  <mat-form-field
    [matTooltip]="
      control?.disabled && tooltipIfDisabled ? tooltipIfDisabled : ''
    "
    appearance="{{ appearance }}"
    (click)="datePicker.open()">
    <mat-label>{{ label }}</mat-label>
    <input
      readonly
      required
      [errorStateMatcher]="matcher"
      matInput
      [matDatepickerFilter]="prevDateDisabledKey ? prevDateDisabled : null"
      [matDatepicker]="datePicker"
      [formControl]="control"
      [value]="value"
      [max]="max"
      [min]="min"
      (dateChange)="onDateChange($event)"
      [formControlName]="formControlName" />
    <mat-hint>{{ hint }}</mat-hint>
    <mat-error *ngIf="errorFromApi" class="mb-5">
      {{ errorFromApi }}
    </mat-error>
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker
      [panelClass]="UIThemeService.purpleDarkThemeFieldPanel() | async"
      #datePicker></mat-datepicker>
    <mat-error *ngIf="formControlFunc!?.errors?.required">
      {{ requiredErrorMessage }}
    </mat-error>
  </mat-form-field>
</div>
